import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isModal',
})(({ theme, isModal }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
  minHeight: 'calc(100vh - 128px)',

  [theme.breakpoints.up('xl')]: {
    width: isModal ? undefined : '100%',
  },

  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },

  '& .MuiTab-labelIcon': {
    minHeight: 50,
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.getContrastText(theme.palette.primary.dark),

  '& .MuiTab-root': {
    color: 'inherit',
    opacity: 0.75,
    '&.Mui-selected': {
      opacity: 1,
    },
  },

  '& .MuiTab-wrapper': {
    flexDirection: 'row',
  },
  '& .MuiTab-wrapper > *:first-child': {
    marginBottom: 0,
    marginRight: theme.spacing(1),
  },
}));

export const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: theme.breakpoints.values['lg'],
  margin: 'auto',
  textAlign: 'left',
  marginBottom: theme.spacing(2),
}));
